import { createI18n } from 'vue-i18n';
import zh_CN from 'ant-design-vue/es/locale/zh_CN';
import en_US from 'ant-design-vue/es/locale/en_US';
import { ref } from "vue";

const messages = {};
const locales = [
    {
        label: '简体中文',
        value: 'zh_hans',
        antdLocale: zh_CN,
        accept: 'zh-CN',
    },
    {
        label: 'English (US)',
        value: 'en_us',
        antdLocale: en_US,
        accept: 'en-US',
    },
];
const antdLocale = ref(locales[0].antdLocale);

// 使用 require.context 动态导入语言包
const modulesFiles = require.context('./locale', true, /\.json$/);

modulesFiles.keys().forEach(modulePath => {
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1').replace(/-/g, '_');
    console.debug('加载国际化资源文件: ', moduleName);
    messages[moduleName] = modulesFiles(modulePath);
});

// 创建 i18n 实例
const i18n = createI18n({
    legacy: false, // 使用 Composition API 模式
    locale: locales[0].value, // 默认语言
    fallbackLocale: locales[0].value, // 回退语言
    messages // 语言包
});

// 获取当前语言（内部标记）
const getCurrentLanguage = () => {
    return i18n.global.locale.value;
}

export default i18n;

export const i18nManager = {
    // 设置语言
    setLanguage: (locale) => {
        console.info('切换语言: ' + locale);
        let _loc = undefined;
        for (let i = 0; i < locales.length; i++) {
            if (locales[i].value === locale) {
                _loc = locales[i];
                break;
            }
        }
        if (_loc === undefined) {
            console.error('未找到语言: ' + locale);
            return;
        }
        i18n.global.locale.value = _loc.value;
        // 设置其他组件的语言
        antdLocale.value = _loc.antdLocale;
        // 设置到缓存中
        window.localStorage.setItem('sso-locale', _loc.value);
        // 设置html的lang属性
        try {
            document.getElementsByTagName('html')[0].setAttribute('lang', _loc.accept);
        } catch (e) {
            console.error(e);
        }
    },
    // 获取当前语言
    getCurrentLanguage: getCurrentLanguage,
    // 获取国际化列表
    getLanguages: () => {
        return locales;
    },
    // 获取请求头accept-language的语言标记
    getAcceptLanguage: () => {
        let locale = getCurrentLanguage();
        let _loc = undefined;
        for (let i = 0; i < locales.length; i++) {
            if (locales[i].value === locale) {
                _loc = locales[i];
                break;
            }
        }
        if (_loc === undefined) {
            console.error('未找到语言: ' + locale);
            return locales[0].accept;
        }
        return _loc.accept;
    },
    text: i18n.global.t,
    antdLocale,
};
